import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TabContent, TabPane } from 'reactstrap';
// import { Operation } from '../../../services/types/Operation';
import { SpinnerArea, TabBar } from '../../shared/components';
// import GIEsInfo from './GIEsInfo';
// import GIFinantialData from './GIFinantialData';
// import GIOperationInfo from './GIOperationInfo';
import { GrievanceItem } from '../../services/types/Grievance';
import GIEsInfo from './GIEsInfo';
import GIOperationInfo from './GIOperationInfo';
import GIFinantialData from './GIFinantialData';
import GIGrievanceInfo from './GIGrievanceInfo';
import GIMICIInfo from './GIMICIInfo';

interface Props {
  grievance: GrievanceItem;
  loading: boolean;
}

const GeneralInformationTabContainer: React.FC<Props> = ({ grievance, loading }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(4);

  const hasMiciData = grievance.miciHighlightDataRows && grievance.miciHighlightDataRows.length > 0;

  const tabHeaders = grievance.operationNumber
    ? [
        { id: 1, text: t('esInformation'), htmlId: 'tabEsInformation' },
        { id: 2, text: t('operationInformation'), htmlId: 'tabOperationInformations' },
        { id: 3, text: t('financialData'), htmlId: 'tabFinancialData' },
        { id: 4, text: t('grievanceInformation'), htmlId: 'tabGrievanceInformation' },
        { id: 5, text: t('mici'), htmlId: 'tabMiciInformation' },
      ].filter((tab) => tab.id !== 5 || hasMiciData)
    : [{ id: 4, text: t('grievanceInformation'), htmlId: 'tabGrievanceInformation' }];

  const toggle = (tabId: number) => {
    if (activeTab !== tabId) {
      setActiveTab(tabId);
    }
  };

  return (
    <SpinnerArea loading={loading}>
      {grievance.operationNumber ? (
        <>
          <TabBar tabSelected={activeTab} setTabSelected={toggle} headers={tabHeaders} />
          <TabContent activeTab={activeTab}>
            {tabHeaders.map((tab) => (
              <TabPane key={tab.id} tabId={tab.id}>
                {tab.id === 1 && <GIEsInfo grievance={grievance} />}
                {tab.id === 2 && <GIOperationInfo grievance={grievance} />}
                {tab.id === 3 && <GIFinantialData grievance={grievance} />}
                {tab.id === 4 && <GIGrievanceInfo grievance={grievance} />}
                {hasMiciData && tab.id === 5 && <GIMICIInfo grievance={grievance} />}
              </TabPane>
            ))}
          </TabContent>
        </>
      ) : (
        <>
          <TabBar
            id="grievanceGeneralInformation"
            tabSelected={activeTab}
            setTabSelected={toggle}
            headers={tabHeaders}
          />
          <TabContent activeTab={activeTab}>
            {tabHeaders.map((tab) => (
              <TabPane key={tab.id} tabId={tab.id}>
                {tab.id === 4 && <GIGrievanceInfo grievance={grievance} />}
              </TabPane>
            ))}
          </TabContent>
        </>
      )}
    </SpinnerArea>
  );
};

export default GeneralInformationTabContainer;
